import React from 'react';
import { Helmet } from 'react-helmet-async';

const Iubenda: React.FC = () => {
  return (
    <Helmet>
      {/* Script widget iubenda - gestisce automaticamente cookie solution e privacy policy */}
      <script
        type="text/javascript"
        src="https://embeds.iubenda.com/widgets/e8d3ead1-8275-4ed9-900e-94a646823cb2.js"
      />
    </Helmet>
  );
};

export default Iubenda;

